<template>
  <div class="Background">
    <div style="display: flex; justify-content: space-between;">
      <h2 class="Title">
        CDN 등록
      </h2>

      <div class="link_location">
        설정관리 <v-icon small class="mdi mdi-chevron-right" />
        시스템설정 <v-icon small class="mdi mdi-chevron-right" />
        <a href="/cdn/create_wowzaserver">CDN 등록</a>
      </div>
    </div>

    <v-card class="pa-5 rounded-0" elevation="0">
      <v-row>
        <v-col cols="6" xs="12">
          <v-card-title>
            <h3>Wowza Server</h3>
          </v-card-title>

          <v-combobox v-model="selServer" :items="wowzaServersItem" outlined color="black" class="ma-3" />
        </v-col>

        <v-col md="2" xs="12">
          <v-card-title>
            <h3>타입</h3>
          </v-card-title>
          <v-radio-group v-model="column" column class="ml-5">
            <v-radio label="Tencent" value="Tencent" class="mt-2" color="black" />
          </v-radio-group>
        </v-col>
      </v-row>
    </v-card>

    <v-row justify="end" class="mt-3 mr-0">
      <v-col v-for="count in 1" :key="count" cols="auto">
        <v-btn elevation="0" outlined class="ml-2" @click="cancel">
          취소
        </v-btn>
        <v-btn elevation="0" dark class="ml-2" :loading="isLoading" @click="createCdn">
          생성
        </v-btn>
      </v-col>
    </v-row>

  </div>
</template>

<script>
import WowzaServerApi from "@/api/wowzaserver/WowzaServerApi";
import CdnApi from "@/api/cdn/CdnApi";

export default {
  data() {
    return {
      wowzaServersItem: [],
      selServer: null,
      column: 'Tencent',
      isLoading: false,
    }
  },
  mounted() {
    this.wowzaServerList();
  },
  methods: {
    async wowzaServerList() {
      try {
        const response = await WowzaServerApi.listForCdnCreateApi();
        this.wowzaServersItem = response.wowzaServers;

      } catch (error) {
        console.error('error', error);
      }
    },
    cancel() {
      this.$router.push('/cdn');
    },
    async createCdn() {
      this.isLoading = true;
      const word = this.splitWord(this.selServer);
      const data = {
        wowzaServersItem: word,
        column: this.column,
        ip: window.location.protocol + '//' + window.location.hostname,
      }
      console.log('data', data);
      const response = await CdnApi.addApi(data);
      if (response.status === 200) {
        this.isLoading = false;
        this.$router.push('/cdn');
      }
    },
    splitWord(word) {
      const words = word.split(' ');
      console.log('!', words);
      if (words.length > 0) {
        this.word = words[0];
      }
      else {
        this.firstWord = '';
      }
      return this.word;
    }
  }
}
</script>

<style lang="scss" scoped></style>